<template>
    <div>
        Mit Aktivierung dieser Option legen Sie fest, dass
        <strong>alle zurückliegenden Termine</strong> automatisch nach X Tagen/Monaten <strong>anonymisiert</strong> werden.
        <br>
        Dabei werden alle persönlichen Daten <strong>unwiderruflich</strong> gelöscht.
        <br/>
        <br/>
        Die automatische Anonymisierung der Termine wird vom System ab dem nächsten Tag 1x täglich um ca. 6 Uhr vorgenommen.
        <br>
    </div>
</template>

<script setup lang="ts">
    import {usePortuna} from '@/composables/portuna';
    import {popupDefaultCancelButton} from '@/library/popup';
    import type {TinyEmitter} from 'tiny-emitter';
    import {inject} from 'vue';

    const popupEmitter = inject<TinyEmitter>('popup-emitter')!;

    const portuna = usePortuna();

    const emit = defineEmits<{
        confirmed: [...args: unknown[]];
    }>();

    popupEmitter.emit('setButtons', [
        popupDefaultCancelButton,
        {
            title: 'Verstanden',
            type: 'primary',
            icon: 'check_circle',
            cmd: () =>
            {
                popupEmitter.emit('confirmed');
                popupEmitter.emit('close');
            },
        },
    ]);

    defineExpose(Object.assign({}, portuna));
</script>